
import React, { useState, useEffect ,useRef} from "react";
import { AppBar, Toolbar, Box } from "@mui/material";
import NMH_LOGO_White_RGB from '../../Assets/NMH_LOGO_White_RGB.png';
import {  useNavigate } from "react-router-dom";
import { KeyboardArrowDown } from '@mui/icons-material';
import {  Typography,ListItemText, Popper, Paper, MenuList, MenuItem, ClickAwayListener, Grow } from "@mui/material";
import './toolbar.css';
import axios from 'axios';

const EditorToolbar = () => {
  const navigate = useNavigate();
  const [userName, setUsername] = useState('');
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

const [openAddMenu, setOpenAddMenu] = useState(false);
const addMenuRef = useRef(null);
  const addPost = async () => {
  try {
    navigate('/Add-Post');
  } catch (error) {
    console.error('Error Adding post:', error);
  }
};
const homepage = async () => {
  try {
    navigate('/Homepage');
  } catch (error) {
    console.error('Error going to homepage:', error);
  }
};
 const savedPosts = async () => {
  try {
    navigate('/Saved-Events');
  } catch (error) {
    console.error('Error Adding post:', error);
  }
};
  const review = async () => {
  try {
    navigate('/Review-Posts');
  } catch (error) {
    console.error('Error Adding post:', error);
  }
};
  const addGuide = async () => {
  try {
    navigate('/College-Counseling-Resources');
  } catch (error) {
    console.error('Error Adding post:', error);
  }
};
const logout = async () => {
  try {
    navigate('/login');
  } catch (error) {
    console.error('Error logging out:', error);
  }
};
const category = async () => {
  try {
    navigate('/Manage-Categories');
  } catch (error) {
    console.error('Error going to manageCategories:', error);
  }
};  
const logoutAll = async () => {
  try {
      await axios.post(`${API_BASE_URL}/api/auth/logout`, {}, { withCredentials: true });
      localStorage.clear();
      sessionStorage.clear();

    //   const oktaIframe = document.createElement('iframe');
    //   oktaIframe.src = `https://nmhschool.okta.com/login/signout`;
    //   oktaIframe.style.display = 'none';
    //   document.body.appendChild(oktaIframe);
      const googleLogoutWindow = window.open(`https://accounts.google.com/logout`, '_blank');

      setTimeout(() => {
          if (googleLogoutWindow) googleLogoutWindow.close(); 
        //   document.body.removeChild(oktaIframe); 
          navigate('/login'); 
      }, 3000);
  } catch (error) {
      console.error('Logout failed:', error.message);
  }
};


const handleToggle = () => {
  setOpen((prevOpen) => !prevOpen);
};

const handleClose = () => {
  setOpen(false);
};

const getUsernamefromCookie = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/isLoggedIn`, {
        withCredentials: true,
      });
      if (response.data.username && response.data.user === 'Editor') {
        setUsername(response.data.username);
      } else {
        navigate("/login");
      }
    } catch (error) {
      console.error("Error fetching login status:", error);
      navigate("/login");
    }
  };

  useEffect(() => {
    getUsernamefromCookie();
  }, []);
   const HeaderOffset = () => (
    <Toolbar sx={{ minHeight: { xs: 200, sm: 80, lg: 70 } }} />
  );
return( <>
{/* <div> */}
  <AppBar position="fixed" className="app-bar"   sx={{ backgroundColor: '#002855', color: 'white',
                  height: {
                    xs: '200px', 
                    sm: '80px',  
                    lg: '70px',
                  },}}>
          <Toolbar>
            <img src={NMH_LOGO_White_RGB} className="toolbar-logo" alt="NMH Logo" />
         
             <Typography  sx={{ fontSize: '0.85rem',padding:1}}>{userName} </Typography>
            
            <Typography  className="title"   sx={{ fontSize: '1.1rem', fontWeight: 'bold', textAlign: 'center' }} >Opportunities Beyond Campus</Typography>


            <Box className="user-section">



            <MenuItem button onClick={homepage} sx={{ padding:1}}>
              <ListItemText primary={<Typography sx={{ fontSize: '0.85rem'}}>Homepage</Typography>} />
              </MenuItem>
              
              <MenuItem button  sx={{ padding:2}} onClick={savedPosts}>
                              <ListItemText primary={<Typography sx={{ fontSize: '0.85rem'}}>Saved Events</Typography>} />
              </MenuItem>
           <MenuItem onClick={() => { handleClose(); addPost(); }}>
                                  <ListItemText primary={<Typography sx={{ fontSize: "0.85rem" }}>Add Post</Typography>} />
            </MenuItem>
             <MenuItem onClick={() => { handleClose(); review(); }}>
                                  <ListItemText primary={<Typography sx={{ fontSize: "0.85rem" }}>Pending</Typography>} />
            </MenuItem>
            <MenuItem onClick={() => { handleClose(); category(); }}>
                                  <ListItemText primary={<Typography sx={{ fontSize: "0.85rem" }}>Tags</Typography>} />
            </MenuItem>
            <MenuItem onClick={() => { handleClose(); addGuide(); }}>
                             <ListItemText primary={<Typography sx={{ fontSize: "0.85rem" }}>College Counseling Resources</Typography>} />
            </MenuItem>
            {/* <MenuItem button ref={anchorRef} onClick={handleToggle} >
                      <ListItemText primary={<Typography sx={{ fontSize: "0.85rem",padding:0}}>Manage Options  </Typography>} />
            </MenuItem> */}
                    
                    {/* <Popper open={open} anchorEl={anchorRef.current} placement="bottom-start" transition modifiers={[
                              {
                                name: 'zIndex',
                                enabled: true,
                                phase: 'write',
                                fn({ state }) {
                                  state.styles.popper.zIndex = 1300;
                                },
                              },
                            ]}
                          >
                      {({ TransitionProps }) => (
                        <Grow {...TransitionProps} style={{ transformOrigin: "left top" }}>
            <Paper sx={{ backgroundColor: 'white',zIndex: 1300,  boxShadow: 3}}>
                            <ClickAwayListener onClickAway={handleClose}>
                              <MenuList>     
                                <MenuItem onClick={() => { handleClose(); addPost(); }}>
                                  <ListItemText primary={<Typography sx={{ fontSize: "0.85rem" }}>Add Post</Typography>} />
                                </MenuItem>
                              </MenuList>
                            </ClickAwayListener>
                          </Paper>
                        </Grow>
                      )}
                    </Popper>                 */}
                {/* <MenuItem button onClick={logout} sx={{ padding:2}}>
                <ListItemText primary={<Typography sx={{ fontSize: '0.85rem', fontWeight: 'bold'}}>Logout</Typography>} />
                </MenuItem> */}
                <MenuItem button onClick={logoutAll} sx={{ padding:2}}>
                <ListItemText primary={<Typography sx={{ fontSize: '0.85rem', fontWeight: 'bold'}}>Logout</Typography>} />
                </MenuItem>
              </Box>
          </Toolbar>
        </AppBar>
      <HeaderOffset/>
{/* 
<AppBar position="static" className="app-bar">
        <Toolbar className="toolbar">
          <img src={NMH_LOGO_White_RGB} className="toolbar-logo" alt="NMH Logo" />
          <Typography className="title">Opportunities Beyond Campus</Typography>
          <Box display="flex" alignItems="center" gap={3} >
          <MenuItem  onClick={() => {navigate("/adminHomepage"); }}>
          HOMEPAGE
        </MenuItem>
      <Box>
      <Button
       sx={{ color: "white" }}
        onClick={handleClick}
        endIcon={<KeyboardArrowDown />}
      >
         OPTIONS
         </Button>
        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem  onClick={() => { handleClose(); navigate("/Add-Post"); }}>
            Add a Post
          </MenuItem>
          <MenuItem onClick={() => { handleClose(); navigate("/Pending-Events"); }}>
            Manage New Events
          </MenuItem>
          <MenuItem onClick={() => { handleClose(); navigate("/manageUser"); }}>
            Manage Users
          </MenuItem>
          <MenuItem onClick={() => { handleClose(); navigate("/manageCategories"); }}>
            Manage Categories
          </MenuItem>
        </Menu>
      </Box>
      <MenuItem  onClick={() => {navigate("/"); }}>
      LOGOUT
        </MenuItem>
    </Box>
        </Toolbar>
      </AppBar> */}
      {/* </div> */}
       </>
  );
};

export default EditorToolbar;